import React, { useEffect, useState } from 'react'
import {
  CButton,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CForm,
  CFormCheck,
  CMultiSelect,
} from '@coreui/react-pro'
import ClubService from 'src/service/ClubService'
import UserService from 'src/service/UserService'

const AssignMembershipPlan = (props) => {
  const [userGameList, setUserGameList] = useState([])
  const [selectedGames, setSelectedGames] = useState([])
  const [showConfirm, setShowConfirm] = useState(false)
  const [finalPayload, setFinalPayload] = useState(null)

  const getUserGame = () => {
    ClubService.getUserAllActivatedGameList(props.selectedUserId).then((res) => {
      if (res.status === 200) {
        setUserGameList(res.data)
      }
    })
  }

  useEffect(() => {
    getUserGame()
  }, [])

  // Step 1: main modal submit → open confirm modal
  const handleSubmit = (e) => {
    e.preventDefault()

    if (props.membershipType === '1' && selectedGames.length === 0) {
      alert('Please select at least one game.')
      return
    }

    const payload = {
      membershipType: props.membershipType,
      gameIds: props.membershipType === '1' ? selectedGames : [],
    }

    setFinalPayload(payload)
    setShowConfirm(true) // show Are you sure?
  }

  // Step 2: final YES → call API
  const handleFinalConfirm = () => {
    const { membershipType, gameIds } = finalPayload

    const payload = {
      userId: props.selectedUserId,
      status: 1,
      membershipType,
      gameIds,
    }

    UserService.changeMembership(payload).then((res) => {
      props.refresh() // parent fetchData
      props.toast(res.message, 'success')
      setShowConfirm(false)
      props.setShowModal(false)
    })
  }

  return (
    <>
      {/* MAIN MEMBERSHIP SELECTION MODAL */}
      <CModal visible={props.showModal} onClose={() => props.setShowModal(false)}>
        <CModalHeader>
          <CModalTitle>Select Membership Type</CModalTitle>
        </CModalHeader>

        <CForm onSubmit={handleSubmit}>
          <CModalBody>
            <div>Select which type of membership to mark as paid:</div>

            <div className="mt-3">
              {/* GAME MEMBERSHIP */}
              <CFormCheck
                type="radio"
                name="membershipType"
                label="Game Membership"
                value="1"
                checked={props.membershipType === '1'}
                onChange={(e) => {
                  props.setMembershipType(e.target.value)
                  setSelectedGames([])
                }}
              />

              {props.membershipType === '1' && (
                <CMultiSelect
                  className="mt-2"
                  name="team"
                  options={userGameList}
                  selectionType="tags"
                  value={userGameList.filter((g) => selectedGames.includes(g.value))}
                  onChange={(selected) => setSelectedGames(selected.map((item) => item.value))}
                />
              )}

              {/* ANNUAL MEMBERSHIP */}
              <CFormCheck
                className="mt-3"
                type="radio"
                name="membershipType"
                label="Annual Membership"
                value="2"
                checked={props.membershipType === '2'}
                onChange={(e) => {
                  props.setMembershipType(e.target.value)
                  setSelectedGames([])
                }}
              />
            </div>
          </CModalBody>

          <CModalFooter>
            <CButton color="secondary" onClick={() => props.setShowModal(false)}>
              Cancel
            </CButton>

            <CButton type="submit" color="primary">
              Confirm
            </CButton>
          </CModalFooter>
        </CForm>
      </CModal>

      {/* CONFIRMATION MODAL */}
      <CModal visible={showConfirm} onClose={() => setShowConfirm(false)}>
        <CModalHeader>
          <CModalTitle>Confirm Activation</CModalTitle>
        </CModalHeader>
        <CModalBody>Are you sure you want to activate membership for this user?</CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setShowConfirm(false)}>
            No
          </CButton>
          <CButton color="primary" onClick={handleFinalConfirm}>
            Yes, Activate
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default AssignMembershipPlan
